/**
 * The `app` this miniapp reports to tracking-service. It must be a value of the
 * service's `AppEnum` — anything else is rejected with a 422 and the event is
 * dropped.
 */
export const TRACKING_APP = 'service_booking_miniapp';

export const HOST_PLATFORMS = {
  MOBILE: 'mobile',
  WEB: 'web',
  TENANT_PORTAL: 'tenant-portal',
} as const;

export type HostPlatform = (typeof HOST_PLATFORMS)[keyof typeof HOST_PLATFORMS];
